var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard-icon)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.999878,
    y: 1,
    width: 9,
    height: 6,
    rx: 2,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.999878,
    y: 11,
    width: 9,
    height: 12,
    rx: 2,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 1,
    width: 9,
    height: 12,
    rx: 2,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 17,
    width: 9,
    height: 6,
    rx: 2,
    fill: "#FEEFD7",
    stroke: "#976821"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c66dc105.svg";
export { ForwardRef as ReactComponent };